import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation User_changeRole($userId: ID!, $roleId: String) {
    User_changeRole(userId: $userId, roleId: $roleId) {
      id
    }
  }
`;

const UserChangeRole = async ({ userId, roleId }) =>
  graphql(mutation, { userId, roleId })
    .then(({ User_changeRole }) => User_changeRole)
    .catch(e => e);

export default UserChangeRole;
